import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiVendorsService} from "./api-vendors.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ApiVendorsService]
})
export class ApiVendorsModule { }
